module.exports = __webpack_public_path__ + "static/media/facade-photo-product.e1b5976c.jpg";